<script>
export default {
  methods: {
    openLoginModal(e) {
      if (e) {
        e.preventDefault()
        e.stopPropagation()
      }
      this.$nextTick(() => {
        this.$nuxt.$emit('closeAllModals')
        this.$nuxt.$emit('openLoginModal')
      })
    },
  },
}
</script>
